import React, { useEffect, useState } from "react";
import "./Inputpop.css"; // Optional external styles
import { Button, Card, Form, Input, message } from "antd";
import {
  CloseCircleOutlined,
  CloseOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../utils/axiosInterceptor";
import { BE_HOST } from "../../config/config";
const InputPopUp = ({ isVisible, onClose, selectedValue,getTargetData, month,year,pharmacy,name,value,email, currentVal, Quarter_GCR, Month_SGCR,Monthly_GPR}) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  useEffect(() => {
      if (isVisible) {
          form.setFieldsValue({Quarter_GCR:Quarter_GCR,Month_SGCR:Month_SGCR,Monthly_GPR:Monthly_GPR});
      }
    }, [isVisible, form]);
  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto"; // Restore on unmount
    };
  }, [isVisible]);
  if (!isVisible) return null;


  const handleSubmit = async (values) => {
    if(values?.Quarter_GCR === Quarter_GCR &&
      values?.Month_SGCR === Month_SGCR &&
      values?.Monthly_GPR === Monthly_GPR){
      message.info("Please update your Target First")
      return;
    }
    let targetKey = "";
    if (selectedValue === "Quarter_GCR") {
      targetKey = "Quarter_GCR";
    } else if (selectedValue === "Month_SGCR") {
      targetKey = "Month_SGCR";
    } else {
      targetKey = "Month_GPR";
    }
    const payload = {
      accounts : pharmacy,
      userName: name,
      targets:{
        // [targetKey]: values?.GCR
        Quarter_GCR:values?.Quarter_GCR,
        Month_SGCR:values?.Month_SGCR,
        Month_GPR:values?.Monthly_GPR
      },
      month:Number(month),
      year:year,
      email:email
    };
    setIsLoading(true);
    try {
      const response = await axiosInstance.post("/powerbi/targets", payload);
      message.success(response.data?.message);
      getTargetData()
      // form.setFieldsValue({
      //   GCR: ""
      // });
    } catch (error) {
    //   message.error(error.response?.data?.message)
    } finally {
      setIsLoading(false);
      onClose()
    }
  };


  return (
    <div className="modal-overlay">
      <div className="modal-content white-modal">
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "end",
            marginBottom: 10,
          }}
        >
          <CloseOutlined className="flex justify-end" onClick={()=>{
            onClose();
            // form.setFieldsValue({
            // GCR: ""
            // });
          }} />
        </div>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className="w-full max-w-md"
        >
          <Form.Item
            name="Quarter_GCR"
            label={
              // selectedValue ===
               "Quarter GCR %"
                // ? "Quarterly GCR"
                // : selectedValue === "Month_SGCR"
                // ? "Monthly SGCR"
                // : "Monthly GPR"
            }
            rules={[
              { required: true, message: "Please enter Value" },
               {
               validator: (_, inputValue) => {
                 if (inputValue === undefined || inputValue === "") {
                   return Promise.resolve();
                 }
               
                 if (Number(inputValue) < Number(currentVal?.QTD_GCR_Percentage) && Number(inputValue)!== 0 || (Number(inputValue) === 0 && Number(Quarter_GCR) > 0 )) {
                   return Promise.reject(
                     new Error(`Value should not be less than ${currentVal?.QTD_GCR_Percentage}`)
                   );
                 }
               
                 return Promise.resolve();
               },
               },
            ]}
          >
            <Input
              // prefix={<LockOutlined />}
              // value={String(value)}
              placeholder="GCR %"
              size="large"
              className="custom-input"
              maxLength="25"
              inputMode="decimal"
              onChange={(e) => {
             let val = e.target.value;
             val = val.replace(/[^0-9.]/g, "");
             const dotCount = (val.match(/\./g) || []).length;
             if (dotCount > 1) {
               val = val.slice(0, val.lastIndexOf("."));
             }
             if (val.includes(".")) {
               const [int, dec] = val.split(".");
               val = `${int}.${dec.slice(0, 2)}`;
             }
             form.setFieldsValue({ Quarter_GCR: val });
           }}
            />
          </Form.Item>

          <Form.Item
            name="Month_SGCR"
            label={ "Monthly SGCR %"}
            rules={[
              { required: true, message: "Please enter Value" },
               {
               validator: (_, inputValue) => {
                 if (inputValue === undefined || inputValue === "") {
                   return Promise.resolve();
                 }
               
                 if ((Number(inputValue) < Number(currentVal?.MON_SGCR_Percentage) && Number(inputValue)!== 0 || (Number(inputValue) === 0 && Number(Month_SGCR) > 0 ))) {
                   return Promise.reject(
                     new Error(`Value should not be less than ${currentVal?.MON_SGCR_Percentage}`)
                   );
                 }
               
                 return Promise.resolve();
               },
               },
            ]}
          >
            <Input
              // prefix={<LockOutlined />}
              // value={String(value)}
              placeholder="SGCR %"
              size="large"
              className="custom-input"
              maxLength="25"
              inputMode="decimal"
              onChange={(e) => {
             let val = e.target.value;
             val = val.replace(/[^0-9.]/g, "");
             const dotCount = (val.match(/\./g) || []).length;
             if (dotCount > 1) {
               val = val.slice(0, val.lastIndexOf("."));
             }
             if (val.includes(".")) {
               const [int, dec] = val.split(".");
               val = `${int}.${dec.slice(0, 2)}`;
             }
             form.setFieldsValue({ Month_SGCR: val });
           }}
            />
          </Form.Item>

          <Form.Item
            name="Monthly_GPR"
            label={"Monthly GPR %"}
            rules={[
              { required: true, message: "Please enter Value" },
               {
               validator: (_, inputValue) => {
                 if (inputValue === undefined || inputValue === "") {
                   return Promise.resolve();
                 }
               
                 if (Number(inputValue) < Number(currentVal?.GPR_Percentage) && Number(inputValue)!== 0 || (Number(inputValue) === 0 && Number(Monthly_GPR) > 0 )) {
                   return Promise.reject(
                     new Error(`Value should not be less than ${currentVal?.GPR_Percentage}`)
                   );
                 }
               
                 return Promise.resolve();
               },
               },
            ]}
          >
            <Input
              // prefix={<LockOutlined />}
              // value={String(value)}
              placeholder="GPR %"
              size="large"
              className="custom-input"
              maxLength="25"
              inputMode="decimal"
              onChange={(e) => {
             let val = e.target.value;
             val = val.replace(/[^0-9.]/g, "");
             const dotCount = (val.match(/\./g) || []).length;
             if (dotCount > 1) {
               val = val.slice(0, val.lastIndexOf("."));
             }
             if (val.includes(".")) {
               const [int, dec] = val.split(".");
               val = `${int}.${dec.slice(0, 2)}`;
             }
             form.setFieldsValue({ Monthly_GPR: val });
           }}
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              size="large"
              className="custom-btn"
              loading={isLoading}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default InputPopUp;
